'use client';

import { useEffect } from 'react';

import TakedaError from '../lib/components/takedaError/TakedaError';
import { env } from '../lib/env';
import { logger } from '../lib/logging/logger';

export const Error = (props: { error: Error }) => {
	const error = !env.isProduction ? props.error : 'Unknown error';

	useEffect(() => {
		if (env.isProduction) {
			logger.error('Error component error', { error });
		}
	}, [error]);

	return <TakedaError error={error} />;
};

export default Error;
